;(function (GC) {
  var cookieName = '_gc_accepted_cookies'

  var logAcceptance = function () {
    var endpoint = '/events/accepted_cookies'
    var config = {
      url: endpoint,
      data: {
        event: 'accepted_cookies',
      },
    }
    // Ideally we would not use jQuery here, but using it for now to
    // give us the optimal browser support. Recommend swapping it out
    // for axios or a fetch polyfill at some point in the future...
    $.ajax(config)
  }

  var setExpire = function (time) {
    var date = new Date(time)
    var newDate = new Date(date.setYear(date.getFullYear() + 1))
    return 'expires=' + newDate.toUTCString()
  }

  var getDomain = function () {
    var domain = window.location.hostname
    return 'domain=' + domain
  }

  var setCookie = function () {
    var cookie = cookieName + '=true'
    var expire = setExpire(Date.now())
    var domain = getDomain()
    var path = 'path=/'
    document.cookie = [cookie, expire, domain, path].join('; ')
  }

  var checkCookie = function () {
    if (
      document.cookie.split(';').filter(function (item) {
        return item.indexOf(cookieName + '=true') >= 0
      }).length
    ) {
      return true
    }
  }

  var addCookieNotification = function () {
    var target = document.querySelector('body')
    var cookiePolicy = document.createElement('div')
    var alertWrapper = document.createElement('div')
    var title = document.createElement('h4')
    var button = document.createElement('button')
    var msg = document.createElement('p')
    var msgText =
      'When you visit our Site, we collect identifiers about you, including your IP address, in order to monitor Site traffic. You may have specific rights related to this information, which you can read about in our <a href="/content/about-us/policy/privacy-policy">Privacy Policy</a> or <a href="/content/about-us/policy/privacy-notice-for-californians">Privacy Notice for Californians</a>. We use cookies to improve our website performance, deliver a more personalized experience, and to analyze our traffic. We also share information about your use of our site with our social media, advertising, and analytics partners. By continuing to browse our site, you accept our privacy and cookie policy.'
    var titleText = 'Cookie Policy'
    var buttonText = 'OK'

    cookiePolicy.id = 'cookie--policy-container'
    cookiePolicy.className = 'container'

    alertWrapper.className =
      'alert fade in col-xs-12 col-sm-12 col-md-12 m-b-xxs fixed--alert cookie--policy'
    alertWrapper.style = ''
    alertWrapper.setAttribute('role', 'alert')

    button.className = 'btn btn-primary btn-outline btn-w-s pull-right m-t-sm'
    button.type = 'button'
    button.setAttribute('data-dismiss', 'alert')

    title.innerText = titleText
    msg.innerHTML = msgText
    button.innerText = buttonText

    button.addEventListener('click', function () {
      logAcceptance()
      setCookie(Date.now())
    })

    var elements = [title, button, msg, button]
    elements.forEach(function (el) {
      alertWrapper.appendChild(el)
    })

    cookiePolicy.appendChild(alertWrapper)
    target.appendChild(cookiePolicy)
  }

  var showCookieMsg = function () {
    var cookieExists = checkCookie()
    var loggedIn = window.logged_in === true

    // This is to try to keep the cookie in place for logged in users.
    if (loggedIn && !cookieExists) {
      setCookie()
    }

    if (cookieExists || loggedIn) {
      return false
    }

    return true
  }

  var cookies = {
    addCookieNotification: addCookieNotification,
    checkCookie: checkCookie,
    setCookie: setCookie,
  }

  GC.cookies = cookies

  $(window).on('load', function () {
    if (showCookieMsg()) {
      addCookieNotification()
    }
  })
})(window.GC || {})
